import React from 'react';
import EventEmitter from 'src/utils/EventEmitter';
import { useAxiosInstance } from 'src/utils/useAxiosInstance';
import { useMutation } from '@tanstack/react-query';

export const UploadSales = () => {
  const { axiosInstance } = useAxiosInstance();

  const downloadTemplate = useMutation({
    mutationFn: async () => {
      const res = await axiosInstance.get('/consignment-transfer-order/get-download-file');
      return res.data;
    },
    onSuccess: (data) => {
      window.open(data.data.signedUrl, '_blank');
    },
  });

  const eEmitter = (customData) => {
    EventEmitter.emit("show_custom_popup", {
      value: true, type: "upload-sales", title: "Cannatrek Consignment Hub",
      data: {
        fileName: customData
      }
    });
  }

  const onFileChange = (e) => {
    eEmitter(e.target.files[0]);
  }

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    // setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      eEmitter(e.dataTransfer.files[0]);
    }
  };

  return (
    <>
      <div className="upload-sales-container">
        <div className="upload-sales-text">
          <strong>IMPORTANT</strong>: Only the Cannatrek Consignment file format can be uploaded. Thank you!
        </div>
        <button className="upload-sales-button" onClick={() => downloadTemplate.mutate()} disabled={downloadTemplate.isPending}>Download Template</button>
      </div>
      
      <div className={`upload_tga-container`} style={{ position: "relative" }}
        onDragEnter={(e) => handleDrag(e)}
      >
        <input id="getFile1" type="file" style={{ opacity: "0", position: "absolute", top: "0", left: "0", right: "0", width: "100%", height: "100%", cursor: "pointer" }} onChange={(e) => {onFileChange(e); e.target.value = null}} />
        <img src="/static/images/icon/upload-icon.svg" alt="upload-icon" style={{ height: "38px" }} />
        <div className="upload_tga-container-text"><span style={{ color: "#057BE9", fontWeight: "600", textDecoration: "underline" }}>Please upload your report here</span></div>
        <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>
      </div>
    </>
  );
}
